"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResultCode = /** @class */ (function () {
    function ResultCode() {
    }
    /**
     * NO_ERROR
     * Hex: 0. Decimal: 0
     */
    ResultCode.IOTIZE_200_NO_ERROR = 0x0;
    /**
     * PENDING
     * Hex: 1. Decimal: 1
     */
    ResultCode.IOTIZE_PENDING = 0x1;
    /**
     * CREATED
     * Hex: 41. Decimal: 65
     */
    ResultCode.IOTIZE_201_CREATED = 0x41;
    /**
     * DELETED
     * Hex: 42. Decimal: 66
     */
    ResultCode.IOTIZE_202_DELETED = 0x42;
    /**
     * CHANGED
     * Hex: 44. Decimal: 68
     */
    ResultCode.IOTIZE_204_CHANGED = 0x44;
    /**
     * CONTENT
     * Hex: 45. Decimal: 69
     */
    ResultCode.IOTIZE_205_CONTENT = 0x45;
    /**
     * BUSY
     * Hex: 46. Decimal: 70
     */
    ResultCode.IOTIZE_206_BUSY = 0x46;
    /**
     * BAD_REQUEST
     * Hex: 80. Decimal: 128
     */
    ResultCode.IOTIZE_400_BAD_REQUEST = 0x80;
    /**
     *
     * Hex: 81. Decimal: 129
     */
    ResultCode.IOTIZE_401_UNAUTHORIZED = 0x81;
    /**
     *
     * Hex: 84. Decimal: 132
     */
    ResultCode.IOTIZE_404_NOT_FOUND = 0x84;
    /**
     *
     * Hex: 85. Decimal: 133
     */
    ResultCode.IOTIZE_405_METHOD_NOT_ALLOWED = 0x85;
    /**
     *
     * Hex: 86. Decimal: 134
     */
    ResultCode.IOTIZE_406_NOT_ACCEPTABLE = 0x86;
    /**
     *
     * Hex: a0. Decimal: 160
     */
    ResultCode.IOTIZE_500_INTERNAL_SERVER_ERROR = 0xa0;
    /**
     * This resource has not been implemented yet
     * Hex: a1. Decimal: 161
     */
    ResultCode.IOTIZE_501_NOT_IMPLEMENTED = 0xa1;
    /**
     *
     * Hex: a3. Decimal: 163
     */
    ResultCode.IOTIZE_503_SERVICE_UNAVAILABLE = 0xa3;
    /**
     *
     * Hex: a4. Decimal: 164
     */
    ResultCode.IOTIZE_504_NVM_ERROR = 0xa4;
    /**
     *
     * Hex: a5. Decimal: 165
     */
    ResultCode.IOTIZE_505_UNABLE_TO_CONNECT_TO_TARGET = 0xa5;
    /**
     *
     * Hex: a6. Decimal: 166
     */
    ResultCode.IOTIZE_506_TARGET_POWER_FAILURE = 0xa6;
    /**
     *
     * Hex: a7. Decimal: 167
     */
    ResultCode.IOTIZE_507_NVM_FUL = 0xa7;
    /**
     *
     * Hex: b0. Decimal: 176
     */
    ResultCode.IOTIZE_TARGET_PROTOCOL_ERROR = 0xb0;
    /**
     *
     * Hex: b1. Decimal: 177
     */
    ResultCode.IOTIZE_TARGET_PROTOCOL_BUSY = 0xb1;
    /**
     *
     * Hex: b2. Decimal: 178
     */
    ResultCode.IOTIZE_TARGET_PROTOCOL_REAL = 0xb2;
    /**
     *
     * Hex: b3. Decimal: 179
     */
    ResultCode.IOTIZE_TARGET_PROTOCOL_WRONG_PARAM = 0xb3;
    /**
     *
     * Hex: b4. Decimal: 180
     */
    ResultCode.IOTIZE_TARGET_PROTOCOL_FORBIDDEN = 0xb4;
    /**
     *
     * Hex: b5. Decimal: 181
     */
    ResultCode.IOTIZE_TARGET_PROTOCOL_DATA = 0xb5;
    /**
     *
     * Hex: b6. Decimal: 182
     */
    ResultCode.IOTIZE_TARGET_PROTOCOL_COM = 0xb6;
    /**
     *
     * Hex: b7. Decimal: 183
     */
    ResultCode.IOTIZE_TARGET_PROTOCOL_LOST_COM = 0xb7;
    /**
     *
     * Hex: b8. Decimal: 184
     */
    ResultCode.IOTIZE_TARGET_PROTOCOL_PARAM = 0xb8;
    /**
     *
     * Hex: b9. Decimal: 185
     */
    ResultCode.IOTIZE_TARGET_PROTOCOL_INT = 0xb9;
    /**
     *
     * Hex: ba. Decimal: 186
     */
    ResultCode.IOTIZE_TARGET_PROTOCOL_ABORT = 0xba;
    /**
     *
     * Hex: bb. Decimal: 187
     */
    ResultCode.IOTIZE_TARGET_PROTOCOL_NOT_IMPLEMENTED = 0xbb;
    return ResultCode;
}());
exports.ResultCode = ResultCode;
